/// <reference path='../../../typings/hibachiTypescript.d.ts' />
/// <reference path='../../../typings/tsd.d.ts' />

//import Alert = require('../model/alert');
import {Alert} from "../model/alert";

interface IAlertService {
    get ():Alert[];
    addAlert (alert:Alert):void;
    addAlerts (alerts:Alert[]):void;
    removeAlert (alert:Alert):void;
    getAlerts ():Alert[];
    formatMessagesToAlerts (messages):Alert[];
    removeOldestAlert ():void;
    newAlert ():Alert;
}

class AlertService implements IAlertService{
    private alerts: Alert[];
    //@ngInject
    constructor(
        private $timeout: ng.ITimeoutService,
        private ngToast
    ) {
        this.alerts = [];
    }

    newAlert = ():Alert =>{
        return new Alert();
    };

    get = ():Alert[] =>{
        return this.alerts || [];
    };

    addAlert = (alert:any):void =>{
        
        if(alert.msg){
            if (alert.type == 'error') alert.type = 'danger';

            let newToast = this.ngToast.create({
                className: alert.type,
                content:  alert.msg,
                dismissOnTimeout: alert.fade
            });
            alert.toast = newToast;
            this.alerts.push(alert);
        }
    };

    addAlerts = (alerts:Alert[]):void =>{
        angular.forEach(alerts,(alert) => {
            this.addAlert(alert);
        });
    };

    removeAlert = (alert:Alert):void =>{
        // ngToast.dismiss(myToastMsg);
        var index:number = this.alerts.indexOf(alert, 0);
        if(alert.toast != undefined) {
            this.ngToast.dismiss(alert.toast);
        }
        if (index != undefined) {
            this.alerts.splice(index, 1);
        }
    };

    getAlerts = ():Alert[] =>{
        return this.alerts;
    };

    formatMessagesToAlerts = (messages):Alert[] =>{
        var alerts = [];
        if(messages && messages.length){
            for(var message in messages){
                if (messages[message].messageType == "error" && messages[message].message == "Pre Process Displayed Flag must be equal to 1"){
                    //skip this type of message as its just used to display the modal.
                    continue;
                }
                
                var alert = new Alert(messages[message].message, messages[message].messageType);
                // alerts.push(alert);
                if(alert.type === 'error' || alert.type === 'danger'){
                    alert.fade = false;
                } else {
                    alert.fade = true;
                }
                
                this.addAlert(alert);
            }
        }
        return alerts;
    };
    
    removeOldestAlert = ():void =>{
        this.alerts.splice(0,1);
    }
}
export{
  AlertService,
  IAlertService
};





